import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.presenter.VirtualCardPaymentDetailsPresenter`

export default defineMessages({
  fetchingPaymentDetailsErrorToast: {
    id: `${scope}.fetchingPaymentDetailsErrorToast`,
    defaultMessage: 'Error fetching payment details',
  },
})
